import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useSnackbarStoreComponent } from '@/stores/useSnackbar';

export const GlobalSnackbar: React.FC = () => {
  const { visible, message, severity, hideSnackbar, maxWidth } =
    useSnackbarStoreComponent();

  const handleClose = (_: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    hideSnackbar();
  };

  return (
    <Snackbar
      open={visible}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{
          width: maxWidth ?? '100%',
          backgroundColor:
            severity === 'success'
              ? '#34A013'
              : severity === 'error'
              ? '#D2232A'
              : severity === 'warning'
              ? '#ED6C02'
              : severity === 'info'
              ? '#2E3B55'
              : undefined,
          color: '#FFFFFF', // Texto branco para contraste
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
